import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmSignUp } from "../../utils/authHelpers"; 

const VerifyCode = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const storedEmail = localStorage.getItem("email");
  const email = location.state?.email || storedEmail; 
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (!email) {
    setError("Email not found. Please try again.");
    return null; 
  }

  const handleVerify = async () => {
    if (!code) {
      setError("Please enter the verification code.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      await confirmSignUp(email, code); 
      setError(""); 
      alert("Verification successful!");

      // Store "isNewUser" flag
      localStorage.setItem("isNewUser", "true");
      localStorage.setItem("email", email); // Store email for retrieval in Signup.js

      // Redirect new users to Signup.js
      navigate("/signupp");
    } catch (err) {
      setError(err.message || "Verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

      

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-[#1C1C1C] text-white px-4 sm:px-6">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 sm:top-6 sm:left-6 text-[#CBDF52] flex items-center z-10"
      >
        <span className="text-base sm:text-lg">← Back</span>
      </button>

      {/* Verification Box */}
      <div className="bg-[#2F2D2D] w-full max-w-[757px] min-h-[400px] rounded-lg flex flex-col items-center justify-center p-6 sm:p-8 mx-4">
        <h1 className="font-[Montserrat] font-bold text-2xl sm:text-[36px] text-white text-center leading-tight">
          Verify Your Account
        </h1>
        <p className="text-white text-center mt-2 text-sm sm:text-base px-2">
          Enter the verification code sent to <b>{email}</b>
        </p>

        {/* Code Input */}
        <div className="mt-6 w-full max-w-[350px]">
          <label className="text-[#65DEF6] text-sm sm:text-md font-semibold mb-2 block">
            Verification Code
          </label>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            className="w-full h-[45px] px-[8px] py-[10px] rounded-lg border border-gray-500 bg-[#2F2F2F] 
            text-white placeholder-gray-400 focus:border-[#CBDF52] focus:outline-none"
            placeholder="Enter code"
          />
        </div>

        {/* Error Message */}
        {error && <p className="text-red-500 text-sm mt-2 text-center px-2 break-words">{error}</p>}

        {/* Verify Button */}
        <button
          onClick={handleVerify}
          disabled={loading}
          className={`mt-6 w-full max-w-[350px] h-[53px] rounded-lg text-black font-semibold text-lg 
          transition duration-300 ${
            loading ? "bg-gray-500" : "bg-[#CBDF52] hover:bg-[#B0C947]"
          }`}
        >
          {loading ? "Verifying..." : "Verify"}
        </button>
        
        
      </div>
      {/* Dog Image (Bottom Right) - Hidden on mobile to prevent overlap */}
      
      <img 
      src="/assets/images/puppy-2.png"
      alt="Dog Illustration" 
      className="absolute w-[230.63px] h-[190.79px] bottom-[50px] right-[50px] hidden sm:block"
      />
      
    </div>
  );
};

export default VerifyCode;
